import { render } from "./SelectFeeApplicability.vue?vue&type=template&id=f845e0f8"
import script from "./SelectFeeApplicability.vue?vue&type=script&lang=js"
export * from "./SelectFeeApplicability.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__